import React from "react";

import HexAuthWrapper from "../../components/HexAuthWrapper";
import TransactionsRoute from "../../features/finance/TransactionsRoute";

const FinanceTransactionsPage = () => (
  <div className="finance-transactions-page full-bleed">
    <HexAuthWrapper>
      <TransactionsRoute />
    </HexAuthWrapper>
  </div>
);

export default FinanceTransactionsPage;
